import React, { Component } from "react";
import { Link } from "react-router-dom";
import "./SupportIssuesTable.css";

const TicketStatus = ({ ticket }) => {
  return (
    <div className="support-issues-table-status-wrapper">
      <div
        className={
          "icon-" + (ticket.status === "solved" || ticket.status === "closed" ? "resolved" : "open")
        }
      >
        <i
          className={
            "fa fa-" +
            (ticket.status === "solved" || ticket.status === "closed"
              ? "check-circle"
              : "ellipsis-h")
          }
        />
      </div>
      <div className="status-info">
        <span className="title">
          {ticket.status === "solved" || ticket.status === "closed" ? "Resolved" : "Open"}
        </span>
      </div>
    </div>
  );
};

class SupportIssuesTable extends Component {
  handleOnRowClick = ticket => {
    this.props.history.push(`/support-issues/${ticket.ticketId}`);
  };

  sortTickets = tickets => {
    let ticketsSorted = tickets.sort((a, b) => {
      if (a.updatedAtTimestamp < b.updatedAtTimestamp) return 1;
      if (a.updatedAtTimestamp > b.updatedAtTimestamp) return -1;
      return 0;
    });
    return ticketsSorted;
  };

  render() {
    const tickets = this.sortTickets(this.props.tickets);

    if (!tickets || tickets.length === 0) {
      return (
        <div className="fleet-table-no-results">
          No support issues have been found for this search criteria
        </div>
      );
    }

    return (
      <table>
        <thead>
          <tr>
            <th>Subject</th>
            <th>Address</th>
            <th>Last Updated</th>
            <th>Ticket Status</th>
            <th>Priority</th>
          </tr>
        </thead>
        <tbody>
          {tickets.map(ticket => {
            return (
              <tr role="button" onClick={() => this.handleOnRowClick(ticket)}>
                <td>
                  <Link to={`/support-issues/${ticket.ticketId}`}>
                    #{ticket.ticketId} - {ticket.subject}
                  </Link>
                </td>
                <td>{ticket.address}</td>
                <td>{ticket.updatedAtFormatted}</td>
                <td>
                  <TicketStatus ticket={ticket} />
                </td>
                <td>{ticket.priority}</td>
              </tr>
            );
          })}
        </tbody>
      </table>
    );
  }
}

export default SupportIssuesTable;
